import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
const AreasOfWorkForm = ({ methods }) => {

    const { register, watch, setValue, formState: { errors } } = methods;

    const { t } = useTranslation();

    return (
        <>
            <h6 >{t("Areas of Work")}</h6>
            {[
                { id: "infants", label: t("Care of infants/children"), extra: t("Please specify age range") },
                { id: "elderly", label: t("Care of elderly") },
                { id: "disabled", label: t("Care of disabled") },
                { id: "housework", label: t("General housework") },
                { id: "cooking", label: t("Cooking"), extra: t("Please specify cuisines") }
            ].map((work) => (
                <div className="row my-4 p-3 border rounded " key={work.id}>
                    <div className="col-lg-12">

                        <label className="form-check-label mb-3">{work.label}</label>

                        {work.extra && (
                            <input
                                {...register(`areas_of_work.${work.id}.extra`)}
                                type="text"
                                className="form-control my-2"
                                placeholder={work.extra}
                            />
                            
                        )}

                        <div className="row">
                            <div className="col-lg-4">
                                <input
                                    {...register(`areas_of_work.${work.id}.willing`)}
                                    type="checkbox"
                                    className="form-check-input"
                                />
                                <label className="form-check-label">{t("Willing to do this work")}</label>

                            </div>

                            <div className="col-lg-4">
                                <input
                                    {...register(`areas_of_work.${work.id}.experience`)}
                                    type="checkbox"
                                    className="form-check-input"
                                  
                                />
                                <label className="form-check-label">{t("Has experience")}</label>

                                <input
                                    {...register(`areas_of_work.${work.id}.experience_years`)}
                                    type="number"
                                    className="form-control"
                                    placeholder={t("Years of experience")}
                                    disabled={!watch(`areas_of_work.${work.id}.experience`)}
                                />
                                <p className="text-danger">
                                    {errors?.areas_of_work?.[work.id]?.experience_years?.message}
                                </p>
                             </div>


                <div className="col-lg-4">
                    <label className="form-label">{t("Rate from 1 to 5")}</label>
                    <select
                        {...register(`areas_of_work.${work.id}.rating`)}
                        className="form-select"
                    >
                        <option value="">{t("Select")}</option>
                        {[1, 2, 3, 4, 5].map((rate) => (
                            <option key={rate} value={rate}>{rate}</option>
                        ))}
                    </select>
                    <p className="text-danger">
                        {errors?.areas_of_work?.[work.id]?.rating?.message}
                    </p>
                </div>

                        </div>
                    </div>
                </div>
            ))}
            <div className="row">
        <div className="col-lg-12">
            <div className="input-block my-3">
            <div className="mt-3">
                    <label htmlFor="other_skills" className="form-label">{t("Other skills")}</label>
                    <input type="text" {...register("other_skills")} id="other_skills" name="other_skills" className="form-control" placeholder={t("Enter name")} />
                </div>
            </div>
            </div>
            </div>
        </>
    );
};




AreasOfWorkForm.propTypes = {
    methods: PropTypes.shape({
        register: PropTypes.func.isRequired,
        watch: PropTypes.func.isRequired,
        setValue: PropTypes.func.isRequired,
        formState: PropTypes.shape({
            errors: PropTypes.object.isRequired
        }).isRequired
    }).isRequired
};
export default AreasOfWorkForm;    
